module.exports = __webpack_public_path__ + "img/home-or-left-ad.b14291a3.png";